import { render, staticRenderFns } from "./userAddress.vue?vue&type=template&id=060f0d4b&"
import script from "./userAddress.vue?vue&type=script&lang=js&"
export * from "./userAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports